export default __webpack_public_path__ + "static/media/logo.8070e2d5.webp";